<template>
  <section class="container mx-auto py-6 md:py-15">
    <UtilsSkeletonLoading
      v-if="isLoading"
      class="mx-auto w-4/5 h-28 sm:h-[315px] md:h-[495px] mt-3"
    />
    <iframe
      v-else
      :src="companyVideo.attributes?.youtube_url"
      class="mx-auto w-full md:w-4/5 h-[315px] md:h-[495px] xl:h-[580px] mt-3 rounded-lg"
    ></iframe>
  </section>
</template>

<script setup>
const isLoading = ref(true)

const companyVideo = ref([])

const getCompanyVideo = async () => {
  const { data, error, pending } = await useSuitmediaApiData(
    `/api/company-video`,
    {
      query: {
        'fields[0]': 'id',
        'fields[1]': 'youtube_url'
      }
    }
  )

  isLoading.value = pending.value

  if (error.value) {
    throw createError({
      statusCode: 404,
      message: `Company Video does not exist`
    })
  }

  return data.value
}

const video = await getCompanyVideo()
companyVideo.value = video.data
</script>

<style lang="scss" scoped></style>
